// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ewfW","option":"styles_option__2cAbg","active":"styles_active__1rB9n"};